import { render } from "./SearchProducts.vue?vue&type=template&id=5ca60e84"
import script from "./SearchProducts.vue?vue&type=script&lang=js"
export * from "./SearchProducts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__